import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, OutlinedInput } from '@material-ui/core';
import { FormItem, Label } from '../../../onboarding/onboarding-ui-components';
import { useAdminFunctionsContext } from 'contexts';
import styles from './add-merchant-id.module.scss';
import NumberFormat from 'react-number-format';
import { checkEmptyArray } from 'validators/onboarding/onboarding-check-value.validator';

export default function AddMerchantIdComponent(props) {
    const { adminFunctions, setAdminFunctions } = useAdminFunctionsContext();
    const { indexId, onChange } = props;

    return (
        <FormItem>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <Label>Merchant id</Label>
                </Grid>
                <Grid item xs={6} sm={5} md={6}>
                    <NumberFormat
                        className={styles.inputMerchantStoreId}
                        customInput={OutlinedInput}
                        inputProps={{ inputMode: 'numeric' }}
                        pattern="\d*"
                        allowLeadingZeros={true}
                        decimalSeparator={false}
                        allowNegative={false}
                        isNumericString={true}
                        id="merchant-id-input"
                        value={checkEmptyArray(adminFunctions.merchantIds)[indexId] ?? ''}
                        onValueChange={(values) => {
                            const { value } = values;
                            const data = [...adminFunctions.merchantIds];
                            data[indexId] = value;
                            setAdminFunctions({
                                ...adminFunctions,
                                merchantIds: data
                            });
                        }}
                        aria-describedby="outlined-weight-helper-text"
                        labelWidth={0}
                        required
                    />
                </Grid>
                <Grid item xs={2} sm={3} md={2}>
                    <Button variant="contained" color="primary" onClick={onChange}>
                        Add
                    </Button>
                </Grid>
            </Grid>
        </FormItem>
    );
}

AddMerchantIdComponent.propTypes = {
    indexId: PropTypes.number,
    onChange: PropTypes.func
};
